import React, { useState, useEffect, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import NavBar from './NavBar';
import Footer from './Footer';
import UserAvatar from './UserAvatar';
import { Menu, ChevronDown } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { useCore } from '../../hooks/useCore';
import { Box, CircularProgress } from '@mui/material';
import FileUploadButton from '../File/FileUploadButton';
import { LoaderSpinner } from '../Layout/LoaderSpinner';

import { useData } from '../../hooks/useData';
import { useOrganization } from '../../hooks/useOrganization';
// import logo from '../../images/logo_veribase.png';
// import logoedxlight from '../../images/logo_equitasdx_light.png';
// import logoedxdark from '../../images/logo_equitasdx_dark.png';

import logo from '../../images/logomark_fiducia.png';
import logoedxlight from '../../images/logo_fiducia_light.png';
import logoedxdark from '../../images/logo_fiducia_dark.png';
import bgOffice from '../../images/bg_office.jpg';

import { DNA } from 'react-loader-spinner';
import { InputSelect } from '../Input/InputSelect';

const Layout = () => {
  const { user, isAuthenticated } = useAuth();
  const { loading } = useData();
  const { getAccounts, setAccount, accountSelected, getAccountsList } = useOrganization();
  const { theme } = useTheme();
  const { navbarOpen, handleNavbarOpen } = useCore();
  const [isNavbarOpen, setIsNavbarOpen] = useState(true);
  const [contentWidth, setContentWidth] = useState('100%');
  const layoutMainRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const isContractUser = user?.roles?.includes('contract');

  // Navbar width constants (matching _vars.scss)
  const NAVBAR_WIDTH = 240; // $navbar-width
  const NAVBAR_WIDTH_COLLAPSED = 48; // $navbar-width-collapsed

  const toggleNavbar = () => {
    // setIsNavbarOpen(!isNavbarOpen);
    handleNavbarOpen(!navbarOpen);
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  useEffect(() => {
    if (!isContractUser) {
      getAccounts(user.accountId);
    }
  }, []);

  // Calculate and set the content width based on navbar state
  useEffect(() => {
    const calculateContentWidth = () => {
      if (layoutMainRef.current) {
        const containerWidth = layoutMainRef.current.offsetWidth;
        const navbarWidth = navbarOpen ? NAVBAR_WIDTH : NAVBAR_WIDTH_COLLAPSED;
        const availableWidth = containerWidth - navbarWidth;
        
        // Force the content to take up the full available width
        setContentWidth(`${availableWidth}px`);
        
              }
    };

    // Calculate immediately
    calculateContentWidth();

    // Recalculate on window resize
    const handleResize = () => {
      calculateContentWidth();
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [navbarOpen]);

  // Don't show navbar and footer on auth pages
  const isAuthPage = location.pathname === '/login' || location.pathname === '/signup';

  // if (loading) {
  //   return (
  //     <Box
  //       sx={{
  //         display: 'flex',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         minHeight: '100vh',
  //         background: 'var(--bg-main)'
  //       }}
  //     >
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  return (
    <div 
      className={`layout ${theme}`}
      style={{
        // background: 'var(--bg-main)', // Comment out existing background
        backgroundImage: `url(${bgOffice})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundColor: theme === 'light' ? 'rgba(255, 255, 255, 0.77)' : 'rgba(0, 0, 0, 0.77)', /* White overlay at 50% */
        backgroundBlendMode: theme === 'light' ? 'lighten' : 'darken',
      }}
    >
      {!isAuthPage && (
        <>
          <header className="layout-header">
            <div className="header-content">
              <button
                className="navbar-toggle"
                onClick={toggleNavbar}
              >
                <Menu />
              </button>
              <img 
                src={logo} 
                className="header-logo" 
                alt="Veritas" 
                onClick={handleLogoClick}
                style={{ cursor: 'pointer',marginLeft: "1rem",marginRight: 5 }}
              />
              <img 
                src={theme === 'dark' ? logoedxlight : logoedxdark} 
                className="header-logo-edx" 
                alt="EquitasDX" 
                onClick={handleLogoClick}
                style={{ cursor: 'pointer' }}
              />

             

              {!isContractUser && (
                <>
                  {accountSelected && <FileUploadButton style={{marginLeft: 11}} />}
                  <InputSelect
                    title=""
                    onChange={setAccount}
                    value={accountSelected}
                    options={getAccountsList}
                    style={{ marginLeft: 11, paddingRight: 40 }}
                  >
                    <ChevronDown className="select-arrow" size={16} />
                  </InputSelect>
                </>
              )}


            </div>
            {user && isAuthenticated && user !== undefined && user?.firstname ? (
              <UserAvatar user={user} />
            ) : null}
          </header>
          <div className="layout-main" ref={layoutMainRef}>
            <NavBar isOpen={navbarOpen} />
            { loading ? (
              <div className="layout-loader">
                  <DNA height="44" width="44" color="#000000" ariaLabel="dna-loading" wrapperStyle={{}} wrapperClass="dna-wrapper" />
              </div>
            ):null}
            <main 
              className={`layout-content ${navbarOpen ? 'navbar-open' : ''}`}
              style={{ 
                width: contentWidth,
                minWidth: contentWidth,
                flex: 'none' // Prevent flex from overriding our width
              }}
            >
              
              <Outlet />
              
            </main>
          </div>
        </>
      )}
      {isAuthPage && (
        <main className="layout-content">
          <Outlet />
          
        </main>
      )}
      <Footer />
    </div>
  );
};

export default Layout; 
